import React from 'react';
import { Icon, IconProps } from './Icon';

export const RotateIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={0.25}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55664 2.32307C9.79733 2.08238 10.1859 2.07833 10.4307 2.31233L10.4404 2.32307L13.5654 5.44807C13.8059 5.68877 13.8091 6.0764 13.5752 6.32112L13.5654 6.33186L10.4404 9.45686C10.1964 9.70066 9.80066 9.70069 9.55664 9.45686C9.31595 9.21617 9.31287 8.82762 9.54688 8.58284L9.55664 8.57307L11.707 6.42073C11.307 6.38062 10.742 6.35823 9.99805 6.35823C6.89161 6.35832 4.37319 8.8768 4.37305 11.9832C4.37305 15.0898 6.89153 17.6081 9.99805 17.6082C13.0734 17.6082 15.5721 15.1405 15.6221 12.077L15.623 11.9832C15.6232 11.6382 15.903 11.3583 16.248 11.3582C16.5931 11.3582 16.8729 11.6382 16.873 11.9832C16.873 15.7802 13.795 18.8582 9.99805 18.8582C6.20117 18.8581 3.12305 15.7801 3.12305 11.9832C3.12319 8.18645 6.20126 5.10832 9.99805 5.10823H10.0957C10.6532 5.10954 11.1165 5.12327 11.499 5.14924L9.55664 3.20686C9.31595 2.96617 9.31287 2.57762 9.54688 2.33284L9.55664 2.32307Z"
        fill="#515151"
      />
    </Icon>
  );
};
